import "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "popper.js";
import "nouislider";
import "../utils.js";
//import "mdb-ui-kit";
import "bootstrap-sass";

//import "../../vendors/material-kit-pro/assets/js/core/bootstrap-material-design.min.js";
import "../../vendors/material-kit-pro/assets/js/plugins/bootstrap-datetimepicker.js";
import "../../vendors/material-kit-pro/assets/js/plugins/bootstrap-selectpicker.js";
import "../../vendors/material-kit-pro/assets/js/plugins/bootstrap-tagsinput.js";
import "../../vendors/material-kit-pro/assets/js/plugins/jasny-bootstrap.min.js";
import "../../vendors/material-kit-pro/assets/js/plugins/jquery.flexisel.js";

//import "../../vendors/material-kit-pro/assets/js/material-kit.js";
import "../../vendors/slick/slick.js";
import "../../vendors/loadingio/loading-bar.js";
import "../../vendors/js-cookie/js/js.cookie.js";
import "../../js/widgethandler.js";
import "../../js/functions_folkspelr.js";

var folkspel = require.context("../widgets/folkspel/", true, /\.js$/);
folkspel.keys().forEach(folkspel);